import { render, staticRenderFns } from "./LoadingBars.vue?vue&type=template&id=3eb1d912&"
import script from "./LoadingBars.vue?vue&type=script&lang=js&"
export * from "./LoadingBars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports